import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminNewsletter() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/newsletter")
      .then((r) => {
        setItems(r.data.items || []);
        setTotal(r.data.total || 0);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-newsletter-page">
      <p className="overline mb-2">{total} abonnés</p>
      <h1 className="font-serif text-4xl mb-8">Newsletter</h1>

      <div className="bg-white border border-[hsl(var(--border-light))] rounded-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[hsl(var(--bg-subtle))]">
            <tr>
              <th className="text-left px-4 py-3 font-medium">Email</th>
              <th className="text-left px-4 py-3 font-medium">Inscrit le</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={2} className="px-4 py-8 text-center text-[hsl(var(--text-muted))]">Chargement…</td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan={2} className="px-4 py-8 text-center text-[hsl(var(--text-muted))]">Aucun abonné pour le moment.</td></tr>
            ) : items.map((s) => (
              <tr key={s.id} className="border-t border-[hsl(var(--border-light))]">
                <td className="px-4 py-3 font-mono text-xs">{s.email}</td>
                <td className="px-4 py-3 text-xs text-[hsl(var(--text-muted))]">{s.created_at?.slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
